import type {
  LeadListItem,
  GetLeadItemsRequest,
} from '@/apis/generated/dialbunny';
import { LeadListItemFromJSON } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type LeadLeadItemStore = StoreEntity<
  LeadListItem,
  'id',
  GetLeadItemsRequest
>;
export const useLeadListItemStore = apiStoreFactory<
  LeadLeadItemStore['entity'],
  LeadLeadItemStore['id'],
  LeadLeadItemStore['filter'],
  LeadLeadItemStore['createInput'],
  LeadLeadItemStore['updateInput']
>(
  STORE.LEAD_LIST_ITEM,
  { entityIdKey: 'id' },
  {
    readAll: async (filter, { dialbunnyApi, pubSub }, signal) => {
      const result = await dialbunnyApi.getListItemsRaw(filter, { signal });

      return result;
    },
    read: async (itemId, { dialbunnyApi }) => {
      return await dialbunnyApi.getLeadListItem({ itemId });
    },
    bulkRead: async (itemIds, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'LeadListItem',
        ids: itemIds.join(','),
      });

      return result.map(LeadListItemFromJSON);
    },
  },
);
